module.exports = "<div class=\"scanFailed\" style=\"display: block\">\n    <div class=\"statusInfo alert dark alert-info\">\n        <i class=\"icon wb-info-circle text\" aria-hidden=\"true\"></i>\n        <div>Thông báo</div>\n        <div>Rất tiếc vui lòng qua lại sau</div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/evs/scan/box_scan_default.component.html
// module id = ../../../../../src/app/pages/admin/evs/scan/box_scan_default.component.html
// module chunks = 3